import type { RestaurantSiteConfig } from "@/lib/restaurant-platform";

export type PublicPageBrand =
  | "chefs-roma"
  | "tuscan-cove"
  | "generic";

export function getPublicPageBrand(
  siteConfig: Pick<RestaurantSiteConfig, "name"> &
    Partial<Pick<RestaurantSiteConfig, "restaurantId">>,
): PublicPageBrand {
  if (
    siteConfig.restaurantId === "roma-kitchen" ||
    (!siteConfig.restaurantId && siteConfig.name === "Roma Kitchen")
  ) {
    return "chefs-roma";
  }
  if (
    siteConfig.restaurantId === "tuscan-cove" ||
    (!siteConfig.restaurantId && siteConfig.name === "Tuscan Cove Bar & Patio")
  ) {
    return "tuscan-cove";
  }
  return "generic";
}
